import { DateTime } from 'luxon'

// Format a Date as a local YYYY-MM-DD (avoids the UTC shift of toISOString()).
export const toIsoDate = (date: Date) => DateTime.fromJSDate(date).toISODate()!

// Parse a YYYY-MM-DD string as a local Date (avoids the UTC shift of new Date(iso)).
export const parseLocalDate = (iso: string) => DateTime.fromISO(iso).toJSDate()
